/**
 * i18n-лейблы/форматтеры модуля «Отзывы».
 *
 * Состояния и типы целей — закрытые таксономии бэка
 * (internal/reviews/domain). Сырые англ-коды НЕ показываем
 * (feedback_build_to_design_not_api_i18n_mobile).
 */

/** Состояние отзыва → русский лейбл. */
export const REVIEW_STATE_LABEL: Readonly<Record<string, string>> = {
  published: 'Опубликован',
  hidden: 'Скрыт',
  deleted: 'Удалён',
};

/** Состояние отзыва → тон бейджа (.fleet-badge--*). */
export const REVIEW_STATE_TONE: Readonly<Record<string, string>> = {
  published: 'ok',
  hidden: 'muted',
  deleted: 'danger',
};

export function reviewStateLabel(state: string): string {
  return REVIEW_STATE_LABEL[state] ?? state;
}

export function reviewStateTone(state: string): string {
  return REVIEW_STATE_TONE[state] ?? 'muted';
}

/** Тип объекта отзыва → русский лейбл. */
export const TARGET_TYPE_LABEL: Readonly<Record<string, string>> = {
  hotel: 'Отель',
  stay: 'Проживание',
  request: 'Заявка',
  menu_item: 'Блюдо/напиток',
  service: 'Услуга',
  vendor: 'Поставщик',
  room: 'Номер',
};

export function targetTypeLabel(type: string): string {
  const known = TARGET_TYPE_LABEL[type];
  if (known) return known;
  if (!type) return 'Отзыв';
  const human = type.replace(/[_-]+/g, ' ').trim();
  return human.charAt(0).toUpperCase() + human.slice(1);
}

/** Фильтры по состоянию отзыва (значение пусто = все). */
export const REVIEW_FILTERS: ReadonlyArray<{ value: string; label: string }> = [
  { value: '', label: 'Все' },
  { value: 'published', label: 'Опубликованные' },
  { value: 'hidden', label: 'Скрытые' },
];

/** Звёзды рейтинга строкой: 4 → «★★★★☆». */
export function stars(rating: number): string {
  const r = Math.max(0, Math.min(5, Math.round(rating)));
  return '★'.repeat(r) + '☆'.repeat(5 - r);
}

/** ISO → «02.06.2026 19:30» (локаль ru). «—» при невалидной дате. */
export function formatDateTime(iso: string | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
